var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.69789 3.31416L3.9444 6.90933L5.74199 7.78608L7.49548 4.1909C8.21879 2.70789 10.024 2.08632 11.507 2.80963C12.99 3.53294 13.6116 5.33812 12.8882 6.82113L11.1348 10.4163L12.9323 11.293L14.6858 7.69787C15.8957 5.2172 14.8644 2.22195 12.3837 1.01204C9.90304 -0.197861 6.90779 0.833486 5.69789 3.31416ZM10.258 12.2139L8.50453 15.8091C7.78122 17.2921 5.97604 17.9136 4.49303 17.1903C3.01002 16.467 2.38845 14.6618 3.11177 13.1788L4.86525 9.58366L3.06766 8.70692L1.31418 12.3021C0.104273 14.7828 1.13562 17.778 3.61629 18.9879C6.09696 20.1978 9.09221 19.1665 10.3021 16.6858L12.0556 13.0906L10.258 12.2139ZM5.34772 13.1568L8.85469 5.96644L10.6523 6.84318L7.14531 14.0335L5.34772 13.1568Z",
    fill: "#F9F9F9",
    fillOpacity: 0.94
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinksIcon);
export default __webpack_public_path__ + "static/media/links_icon.c1759b16a3c92c4ad978e03d86d458e7.svg";
export { ForwardRef as ReactComponent };